module.exports = __webpack_public_path__ + "img/badge-list-thumb-132.69a57915.png";